import batchUtils from "./batchUtils";
import { BATCH } from "./chainActionTypes";

export const batchActions = batchUtils.createBatchAction;

const chainReducer = reducer => {
  return function (state, action, prevGlobalState) {
    if (action.type === BATCH) {
      let tmp = state;
      action.actions.forEach(a => {
        tmp = reducer(tmp, a, prevGlobalState);
      });
      return tmp;
    } else {
      return reducer(state, action, prevGlobalState);
    }
  };
};

export default chainReducer;
